

// Learn TypeScript:
//  - [Chinese] https://docs.cocos.com/creator/manual/zh/scripting/typescript.html
//  - [English] http://www.cocos2d-x.org/docs/creator/manual/en/scripting/typescript.html
// Learn Attribute:
//  - [Chinese] https://docs.cocos.com/creator/manual/zh/scripting/reference/attributes.html
//  - [English] http://www.cocos2d-x.org/docs/creator/manual/en/scripting/reference/attributes.html
// Learn life-cycle callbacks:
//  - [Chinese] https://docs.cocos.com/creator/manual/zh/scripting/life-cycle-callbacks.html
//  - [English] http://www.cocos2d-x.org/docs/creator/manual/en/scripting/life-cycle-callbacks.html

const { ccclass, property } = cc._decorator;
@ccclass("mapData")
class mapData {
    //  0 和   1 闲家赢 （龙）（蓝）    2 庄家赢（虎）（红） 
    @property(cc.SpriteFrame)
    icons: cc.SpriteFrame[] = [];

    @property(cc.Vec2)
    size: cc.Vec2 = new cc.Vec2(30, 30)

    @property()
    spacing: cc.Vec2 = new cc.Vec2(40, 40)

    @property()
    showMaxRow: number = 8 //显示最大的列数
}


@ccclass
export default class roadmap extends cc.Component {
    @property()
    showMaxRow: number = 8 //显示最大的列数

    @property()
    showMaxHan: number = 6

    @property(cc.Node)
    mapNode: cc.Node[] = [];

    @property(mapData)
    zhuPanLu: mapData = null

    @property(mapData)
    daLu: mapData = null

    @property(mapData)
    daYanLu: mapData = null

    @property(mapData)
    xiaoYanLu: mapData = null

    @property(mapData)
    jiaYouLu: mapData = null

    // @property(cc.Node)
    // addMapBtn:cc.Node = null;

    @property(cc.Node)
    poolNode: cc.Node = null;

    @property(cc.Node)
    labelEx: cc.Node = null;


    //  0 和   1 闲家赢 （龙）（蓝）    2 庄家赢（虎）（红） 
    roadList = [];

    // 大路图数据 二维数组
    protected bigRoad: any[] = []

    protected pool: cc.Node[] = []
    protected configs: mapData[] = [];

    // LIFE-CYCLE CALLBACKS:

    onLoad() {
        this.configs = [this.zhuPanLu, this.daLu, this.daYanLu, this.xiaoYanLu, this.jiaYouLu]
    }

    start() {
        // let self = this
        // self.roadList= [0,0,2,2,2,1,0,2,1,1,1,0,2]
        // self.onRefreshDisplay(self.roadList,null)

        // if(this.addMapBtn){
        //     this.addMapBtn.on("click", () => {
        //         self.roadList.push(Utility.getIntRandom(0,2))
        //         self.onRefreshDisplay(self.roadList)
        //     })
        // }
    }

    //获取路图概述   0 和   1 闲家赢 （龙）（蓝）    2 庄家赢（虎）（红）   3 总数
    getRoadListSummary(roadList) {
        let ret = [0, 0, 0, 0] ////  0 和   1 闲家赢 （龙）（蓝）    2 庄家赢（虎）（红）   3 总数
        roadList = roadList ? roadList : this.roadList

        for (const value of roadList) {
            ret[value] += 1
        }
        ret[3] = roadList.length
        return ret
    }

    //获取下局龙或下局虎 下三路的状态
    getForecastState(xiaSanLuType: number, lastLongOrHu) { //  0 和   1 闲家赢 （龙）（蓝）    2 庄家赢（虎）（红） 
        this.roadList.push(lastLongOrHu)
        this.showRoadMap2(false, this.disposeData(1), true)
        this.roadList.pop()

        return this.showRoadMap3(xiaSanLuType, true)
    }

    public onRefreshDisplay(roadList, mapType = null) {
        this.roadList = roadList ? roadList : this.roadList
        let roadList_show1 = this.disposeData(1)

        this.bigRoad = []
        if (mapType != null) {
            this.reset(mapType)
            switch (mapType) {
                case 0:
                    this.showRoadMap1()
                    break;

                case 1:

                    this.showRoadMap2(false, roadList_show1, false)
                    break;

                case 2:

                    this.showRoadMap2(true, roadList_show1, false)
                    this.showRoadMap3(0)
                    break;

                case 3:

                    this.showRoadMap2(true, roadList_show1, false)
                    this.showRoadMap3(1)
                    break;

                case 4:

                    this.showRoadMap2(true, roadList_show1, false)
                    this.showRoadMap3(2)
                    break;

            }

        } else {
            for (let i = 0; i < this.mapNode.length; i++) {
                this.reset(i)
            }

            this.showRoadMap1()
            this.showRoadMap2(false, roadList_show1, false)

            this.showRoadMap3(0)
            this.showRoadMap3(1)
            this.showRoadMap3(2)
        }
    }

    //处理缩略图数据
    disposeData(mapType: number) {
        if (this.configs.length == 0) {
            this.configs = [this.zhuPanLu, this.daLu, this.daYanLu, this.xiaoYanLu, this.jiaYouLu]
        }

        let tempList = []
        tempList = tempList.concat(this.roadList)

        if (this.configs[mapType] && this.roadList.length > this.configs[mapType].showMaxRow * 6) {
            let needDeleteNum = this.roadList.length - this.configs[mapType].showMaxRow * 6
            for (let i = 0; i < needDeleteNum; i++) {
                tempList.shift()
            }
        }
        return tempList
    }



    //珠盘路
    showRoadMap1() {
        let tempList = []
        tempList = tempList.concat(this.roadList)

        let row = parseInt(String(tempList.length / 6))
        if (tempList.length % 6 != 0) {
            row = row + 1
        }
        let deleteRow = row - this.zhuPanLu.showMaxRow
        if (deleteRow > 0) {
            for (let i = 0; i < deleteRow; i++) {
                for (let j = 0; j < 6; j++) {
                    tempList.shift()
                }
            }
        }

        for (let i = 0; i < tempList.length; i++) {
            this.creatorSprite(tempList[i], 0, new cc.Vec2(parseInt(String(i / 6)) * this.zhuPanLu.spacing.x, i % 6 * - this.zhuPanLu.spacing.y), this.zhuPanLu.size)
        }
    }

    //大路
    showRoadMap2(isOnlyRefreshData: boolean = false, roadList, getlastValus: boolean = false) {
        if (cc.isValid(this.mapNode[1])) {
            this.mapNode[1].active = !isOnlyRefreshData
        }
        this.bigRoad = []

        let row = -1 //列
        let displayRow = 0
        let displayCon = 0
        let maxDisplayCon = 0

        let road = null
        let lastRoad = null
        let tmp = null
        let bigRoadDisplay: any[] = []
        let oneRoundHe = null


        for (let i = 0; i < roadList.length; i++) {
            road = roadList[i]

            if (road == 0) {
                if (i != 0) {
                    let count = 1 //连续 “和”的次数
                    let temp_i = i
                    while (temp_i > 0 && roadList[temp_i - 1] == 0) {
                        count = count + 1
                        temp_i = temp_i - 1

                        if (temp_i - 1 == 0 || (temp_i > 0 && roadList[temp_i - 1] != 0)) {
                            break
                        }
                    }

                    // if(tmp){
                    //     this.creatorLabel(tmp[0], count+"", 30, null)
                    // }
                    if (oneRoundHe != null) {
                        oneRoundHe = count
                    } else {
                        if (bigRoadDisplay[displayRow][displayCon]) {
                            bigRoadDisplay[displayRow][displayCon][1] = count + ""
                        }
                    }


                } else {
                    // bigRoadDisplay[0]=[[null,"1"]]
                    oneRoundHe = 1//this.creatorLabel(this.mapNode[1], "1", 30,null)

                    // lastRoad = road
                    // row= 0
                    // if(this.bigRoad[row] == null ){
                    //     this.bigRoad[row] = []
                    // }
                }

                continue
            }

            if (road != lastRoad) {
                row = row + 1
                maxDisplayCon = 6
            }



            if (this.bigRoad[row] == null) {
                this.bigRoad[row] = []
            }


            displayRow = (this.bigRoad[row].length > maxDisplayCon ? this.bigRoad[row].length - maxDisplayCon : 0) + this.bigRoad.length - 1
            displayCon = this.bigRoad[row].length > maxDisplayCon ? maxDisplayCon : this.bigRoad[row].length

            if (bigRoadDisplay[displayRow] == null) {
                bigRoadDisplay[displayRow] = []
            } else {
                while (bigRoadDisplay[displayRow][displayCon] != null || (road == lastRoad && this.bigRoad[row].length >= 6)) {
                    displayCon = displayCon - 1
                    displayRow = displayRow + 1
                    if (bigRoadDisplay[displayRow] == null) {
                        bigRoadDisplay[displayRow] = []
                    }

                    if (bigRoadDisplay[displayRow][displayCon] == null) {
                        if (maxDisplayCon == 6) {
                            maxDisplayCon = displayCon
                        }

                        break
                    }
                }
            }

            // tmp = this.creatorSprite(this.roadList[i], 1, new cc.Vec2( displayRow * this.daLu.spacing.x, displayCon *  - this.daLu.spacing.y  ), this.daLu.size)

            // this.bigRoad[row][ this.bigRoad[row].length ] = tmp
            // bigRoadDisplay[displayRow][displayCon] = tmp


            this.bigRoad[row][this.bigRoad[row].length] = roadList[i]
            if (oneRoundHe != null) {
                bigRoadDisplay[displayRow][displayCon] = [roadList[i], oneRoundHe + ""]
                oneRoundHe = null
            } else {
                bigRoadDisplay[displayRow][displayCon] = [roadList[i]]
            }


            // if(oneRoundHe){
            //     oneRoundHe[0].setSiblingIndex(1)
            // }
            lastRoad = road
        }

        if (bigRoadDisplay.length > this.daLu.showMaxRow) {
            let needDeleteNum = bigRoadDisplay.length - this.daLu.showMaxRow
            for (let i = 0; i < needDeleteNum; i++) {
                bigRoadDisplay.shift()
                // this.bigRoad.shift()
            }
        }

        //获取下局龙或下局虎 下三路的状态   bigRoadDisplay[i][j][x]  x =0 路图的值   x =1 和的次数   
        if (getlastValus != true) {
            let mp = null
            for (let i = 0; i < bigRoadDisplay.length; i++) {
                for (let j = 0; j < bigRoadDisplay[i].length; j++) {
                    if (bigRoadDisplay[i][j]) {
                        if (bigRoadDisplay[i][j][0] != null) {
                            mp = this.creatorSprite(bigRoadDisplay[i][j][0], 1, new cc.Vec2(i * this.daLu.spacing.x, j * - this.daLu.spacing.y), this.daLu.size)
                            if (bigRoadDisplay[i][j][1] != null) {
                                this.creatorLabel(mp[0], bigRoadDisplay[i][j][1], 18, new cc.Vec2(0, 0))
                            }
                        } else {
                            mp = this.creatorSprite(-1, 1, new cc.Vec2(i * this.daLu.spacing.x, j * - this.daLu.spacing.y), this.daLu.size)

                            this.creatorLabel(mp[0], bigRoadDisplay[i][j][1], 18, new cc.Vec2(0, 0))
                        }
                    }
                }
            }
        }

    }



    //大眼仔路 小路    蟑螂路
    protected xiaSanLuConfig = [new cc.Vec2(1, 1), new cc.Vec2(2, 1), new cc.Vec2(3, 1)]
    showRoadMap3(xiaSanLuType: number, getlastValus: boolean = false) {
        if (this.bigRoad.length == 0) {
            return
        }
        let xiaSanLu: mapData[] = [this.daYanLu, this.xiaoYanLu, this.jiaYouLu]

        let mapList: any[] = []
        let dataList: any[] = []
        let config = this.xiaSanLuConfig[xiaSanLuType]
        let targetInterval = config.x

        let row = -1 //列
        let lastColor = null
        let curColor = null // 2是红色   1 是蓝色
        let displayRow = 0
        let displayCon = 0
        let maxDisplayCon = 0

        for (let i = 0; i < this.bigRoad.length; i++) {

            for (let j = 0; j < this.bigRoad[i].length; j++) {
                curColor = null

                if (lastColor == null && (i < config.x || j < config.y) && i <= config.x) {
                    continue
                }

                if (this.bigRoad[i][j] != null) {

                    //路中
                    if (j != 0) {
                        if (this.bigRoad[i - targetInterval][j] == null && this.bigRoad[i - targetInterval][j - 1] != null) {
                            curColor = 1
                        } else {
                            curColor = 2
                        }
                    } else {//路头
                        if (this.bigRoad[i - targetInterval - 1][this.bigRoad[i - 1].length] == null
                            && this.bigRoad[i - targetInterval - 1][this.bigRoad[i - 1].length - 1] != null) {
                            curColor = 2
                        } else {
                            curColor = 1
                        }
                    }

                    if (lastColor != curColor) {//初始化列 和换列

                        maxDisplayCon = 6
                        row = row + 1
                        dataList[row] = []
                    }

                    displayRow = (dataList[row].length > maxDisplayCon ? dataList[row].length - maxDisplayCon : 0) + dataList.length - 1
                    displayCon = dataList[row].length > maxDisplayCon ? maxDisplayCon : dataList[row].length

                    if (mapList[displayRow] == null) {
                        mapList[displayRow] = []
                    } else {
                        while (mapList[displayRow][displayCon] != null || (lastColor == curColor && dataList[row].length >= 6)) {
                            displayCon = displayCon - 1
                            displayRow = displayRow + 1
                            if (mapList[displayRow] == null) {
                                mapList[displayRow] = []
                            }

                            if (mapList[displayRow][displayCon] == null) {
                                if (maxDisplayCon == 6) {
                                    maxDisplayCon = displayCon
                                }
                                break
                            }
                        }
                    }
                    // tmp = this.creatorSprite(curColor,xiaSanLuType +2,new cc.Vec2( displayRow * xiaSanLu[xiaSanLuType].spacing.x, displayCon * -xiaSanLu[xiaSanLuType].spacing.y  ),xiaSanLu[xiaSanLuType].size )
                    // mapList[displayRow] [ displayCon ] = tmp
                    // dataList[row][dataList[row].length] = tmp
                    mapList[displayRow][displayCon] = curColor
                    dataList[row][dataList[row].length] = curColor
                    lastColor = curColor
                }
            }
        }

        //获取下局龙或下局虎 下三路的状态
        if (getlastValus) {
            return curColor
        }

        if (mapList.length > xiaSanLu[xiaSanLuType].showMaxRow) {
            let needDeleteNum = mapList.length - xiaSanLu[xiaSanLuType].showMaxRow
            for (let i = 0; i < needDeleteNum; i++) {
                mapList.shift()
                dataList.shift()
            }
        }

        for (let i = 0; i < mapList.length; i++) {
            for (let j = 0; j < mapList[i].length; j++) {
                this.creatorSprite(mapList[i][j], xiaSanLuType + 2, new cc.Vec2(i * xiaSanLu[xiaSanLuType].spacing.x, j * -xiaSanLu[xiaSanLuType].spacing.y), xiaSanLu[xiaSanLuType].size)
            }
        }
    }

    reset(mapType) {
        let childrens = this.mapNode[mapType].getComponentsInChildren(cc.Sprite)
        let lab = null
        let nd: cc.Node = null

        for (let i = 0; i < childrens.length; i++) {
            // childrens[i].node.active = false
            nd = childrens[i].node
            if (nd.getComponent(cc.Label)) {
                nd.destroy()
                continue
            }
            nd.color = cc.Color.WHITE
            lab = nd.getComponentInChildren(cc.Label)
            if (lab) {
                lab.node.active = false
            }
            nd.parent = this.poolNode
            this.pool.push(nd)
        }
    }

    getItem(): cc.Node {
        let node = this.pool.pop()

        if (node == null) {
            node = new cc.Node('Sprite');
        }

        //   node.active = true

        return node
    }

    creatorSprite(type: number, mapType: number, v: cc.Vec2, size: cc.Vec2): any {
        var node = this.getItem()

        var sp = node.getComponent(cc.Sprite)
        if (sp == null) {
            sp = node.addComponent(cc.Sprite);
        }
        sp.sizeMode = cc.Sprite.SizeMode.TRIMMED
        sp.spriteFrame = type == -1 ? null : this.configs[mapType].icons[type];
        node.parent = this.mapNode[mapType];

        node.name = String(type);
        if (size.x == size.y) {
            node.setContentSize(size.x, size.y);
        }
        node.position = v

        return [node, type]
    }

    creatorLabel(parentNode: cc.Node, content: string, fontSize: number, pos: cc.Vec2): any {
        let label = parentNode.getComponentInChildren(cc.Label)

        if (label == null) {
            if (this.labelEx) {
                let node: cc.Node = cc.instantiate(this.labelEx);
                label = node.getComponent(cc.Label)
                node.parent = parentNode
                node.parent = parentNode
                node.position = pos == null ? cc.Vec2.ZERO : pos
                node.setSiblingIndex(2)
            } else {
                let node = new cc.Node('Label');
                node.color = cc.Color.GREEN
                label = node.addComponent(cc.Label);
                label.fontSize = fontSize
                node.parent = parentNode
                node.position = pos == null ? cc.Vec2.ZERO : pos
                node.setSiblingIndex(2)

                label.verticalAlign = cc.Label.VerticalAlign.CENTER
            }

        }
        label.node.active = true
        label.string = content
        label.node.y = 1
        return [label.node, 0]
    }
}
